module.exports = __webpack_public_path__ + "media/images/plaid-logo-14632539.svg";